<div class="registroNaoEncontrado">
  <h2>Anúncio não encontrado.</h2>
  <div>
    <a routerLink="/">Voltar para a Página principal</a>
  </div>
</div>
